// extracted by mini-css-extract-plugin
module.exports = {"mark":"highlightText_mark__2QLWu"};